import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Text } from '@nerdwallet/currency';

import HeroNavTile from './hero-nav-tile';
import styles from './hero-nav.module.less';

const HeroNav = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, nav) => (
    <HeroNavTile {...tile} key={`item-${nav}`} />
  ));

  const HeroContainer = <div className={styles.container}>{renderedTiles}</div>;

  return (
    <div className={styles.box}>
      <div className={styles.header}>
        <Text size="large" bold>
          Compare and find the smartest financial products to unlock your
          dreams:
        </Text>
      </div>
      {HeroContainer}
    </div>
  );
};

HeroNav.displayName = 'HeroNav';

HeroNav.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(HeroNav.propTypes)),
  className: PropTypes.string,
  nav: PropTypes.string,
};

export default HeroNav;
